import { lazy } from "react";
import DashboardRevamped from "../container/RevampedDashboard/DashboardRevamped";

// Lazy loaded components
const Dashboard = lazy(() => import("../container/DashboardItem"));
const Candidates = lazy(() => import("../container/Candidates/Lists"));
const AddCandidates = lazy(() => import("../container/Candidates/Add"));
const Positions = lazy(() => import("../container/Positions/Lists"));
const AddPositions = lazy(() => import("../container/Positions/Add"));
const AddQuestions = lazy(() => import("../container/AddQuestions"));
const Recording = lazy(() => import("../container/Recording"));
const Slot = lazy(() => import("../container/Slot"));
const RoutesFile = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardRevamped,
    private: true,
    mainResource: "",
    resource: "",
    action: "",
    redirect: false,
  },
  {
    path: "/positions",
    name: "Positions",
    component: Positions,
    private: true,
    mainResource: "incScreen",
    resource: "positions",
    action: "view",
    redirect: false,
  },
  {
    path: "/create-position",
    name: "AddPositions",
    component: AddPositions,
    private: true,
    mainResource: "incScreen",
    resource: "positions",
    action: "create",
    redirect: false,
  },
  {
    path: "/candidates",
    name: "Candidates",
    component: Candidates,
    private: true,
    mainResource: "incScreen",
    resource: "candidate",
    action: "view",
    redirect: false,
  },
  {
    path: "/create-candidate",
    name: "AddCandidates",
    component: AddCandidates,
    private: true,
    mainResource: "incScreen",
    resource: "candidate",
    action: "create",
    redirect: false,
  },
  {
    path: "/create-questions",
    name: "AddQuestions",
    component: AddQuestions,
    private: true,
    mainResource: "incScreen",
    resource: "positions",
    action: "create",
    redirect: false,
  },
  {
    path: "/recording/:interviewId/:roomId",
    name: "Recording",
    component: Recording,
    private: false,
    mainResource: "",
    resource: "",
    action: "view",
    redirect: false,
  },
  {
    path: "/slot/:interviewId/:roomId",
    name: "Slot",
    component: Slot,
    private: false,
    mainResource: "",
    resource: "",
    action: "view",
    redirect: false,
  },
];

export default RoutesFile;
